module.exports = __webpack_public_path__ + "assets/img/worksetting.81bf7d48.svg";